"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coolHref = coolHref;

var _IGC_JS2Native = require("../IGC_JS2Native");

var _env = require("../env");

var _websdk = require("../websdk");

var _common = require("../common");

var _semver = require("../semver");

/**
 * @file URL 跳转函数
 * @author songqian
 * @date 2020-05-15
 */

/**
 * 处理 App 内外链接跳转
 * 由于 App 内使用自定义 Schema URL: igetcool://，因此需要在 Web 端额外处理跳转逻辑。
 * 其中 H5 跳转使用了 igetcool://juvenile.dedao.app/go/h5?params_url=${encodeURIComponent(url)} 格式，
 * 因此在 App 外环境需要取到 params_url，进行 decode 编码，然后进行跳转。
 * @param {string} url 跳转地址
 * @param {Object=} options 扩展参数
 * @options {boolean=} options.launchAppInH5 在 H5 页面遇到 igetcool://go/h5 时是否唤起 App 并打开该链接，默认 false。
 */
var RCODE_KEY = 'igcReCode';

function coolHref(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var launchAppInH5 = options.launchAppInH5;
  var currentLocationSearchParams = new URLSearchParams(location.search);
  var rcodeCurrent = currentLocationSearchParams.get(RCODE_KEY);
  var nextSearchParams = new URLSearchParams(url);
  var rcodeNext = nextSearchParams.get(RCODE_KEY);
  var newRCode = rcodeCurrent; // 为站内链接拼接rcode作为溯源参数
  // if (isAppProtocol(url) || url.includes('igetcool')) {
  //   if (rcodeNext) {
  //     if (!env.isApp) {
  //       newRCode = rcodeCurrent ? `${rcodeCurrent}_${rcodeNext}` : rcodeNext
  //       url = url.replace(rcodeNext, newRCode)
  //     }
  //   } else {
  //     if (newRCode) {
  //       if (url.includes('?')) {
  //         url = url + `&${RCODE_KEY}=${newRCode}`
  //       } else {
  //         url = url + `?${RCODE_KEY}=${newRCode}`
  //       }
  //     }
  //   }
  // }

  if ((0, _common.isAppProtocol)(url)) {
    if (_env.env.isApp) {
      return (0, _IGC_JS2Native.JS2Native)({
        name: 'navigateTo',
        params: {
          router: url
        }
      });
    } else {
      if (!launchAppInH5 && (0, _common.isAppGoH5Link)(url)) {
        // 在 App 外，且是 http 链接的，直接使用 href 做跳转。无需在唤起 App 了
        window.location.href = (0, _common.appLink2Http)(url);
      } else {
        _websdk.webSDK.openApp(url);
      }

      return Promise.resolve();
    }
  } else if ((0, _common.isHttpProtocol)(url)) {
    if (_env.env.isApp) {
      return (0, _IGC_JS2Native.JS2Native)({
        name: 'navigateTo',
        params: {
          router: (0, _common.http2AppLink)(url)
        }
      });
    } else {
      window.location.href = url;
      return Promise.resolve();
    }
  } else if ((0, _common.isCustomizeSchema)(url)) {
    if (_env.env.isApp) {
      if ((0, _semver.compareVersion)(_env.env.appVer, '3.18.0') >= 0) {
        return (0, _IGC_JS2Native.JS2Native)({
          name: 'openExternalApp',
          params: {
            url: url
          }
        });
      } else {
        return Promise.resolve('所需app版本3.18.0及以上，请升级app版本');
      }
    } else {
      return Promise.resolve('请在app内打开');
    }
  } else {
    var content = '链接格式错误：' + url;

    _common.Log.warn(content);

    return Promise.reject();
  }
}